import type { Theme, SxProps } from '@mui/material';

export const rootSx = (isDisabled: boolean, sx: SxProps<Theme> = []): SxProps<Theme> => {
  return [
    { width: '100%', position: 'relative' },
    isDisabled ? { opacity: 0.6, pointerEvents: 'none' } : {},
    ...(Array.isArray(sx) ? sx : [sx]),
  ];
};
